import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "Quali sono i requisiti principali per ottenere un visto?",
  answer: "I requisiti variano in base alla destinazione e alla tipologia di visto (studio, lavoro o turismo). Generalmente includono un passaporto valido, prove di sostentamento economico, assicurazione sanitaria e documentazione specifica come lettere di invito o certificati di iscrizione scolastica."
}, {
  question: "Quali documenti sono necessari per le gite scolastiche?",
  answer: "Per i gruppi scolastici è necessaria una lista dei partecipanti su carta intestata dell'istituto, l'autorizzazione dei genitori per i minori e, a seconda della meta, il visto collettivo o individuale. Il nostro team coordina l'intera raccolta documentale per semplificare il processo."
}, {
  question: "Quanto tempo prima devo richiedere il visto?",
  answer: "Consigliamo di avviare la pratica almeno 4-8 settimane prima della data di partenza prevista. Sebbene i tempi di elaborazione consolari possano variare, una richiesta anticipata protegge da eventuali ritardi burocratici o richieste di integrazione documentale."
}, {
  question: "Sono previsti sconti per gruppi numerosi o istituti?",
  answer: "Certamente. Offriamo tariffe agevolate e pacchetti personalizzati per gruppi superiori alle 10 persone, agenzie di viaggio e istituti scolastici. Gestiamo la logistica in modo centralizzato per garantire un risparmio significativo sui costi di gestione."
}, {
  question: "Come posso monitorare lo stato della mia pratica?",
  answer: "Una volta affidataci la documentazione, riceverete aggiornamenti costanti via email. Inoltre, il nostro servizio di assistenza dedicato è sempre disponibile per fornire informazioni in tempo reale sull'avanzamento della procedura presso le autorità competenti."
}];
export default function KnowledgeBase() {
  return <section data-section-id="223246" id="domande-frequenti" className="bg-background py-24 px-4 sm:px-6 lg:px-8 text-foreground">
      <div className="mx-auto max-w-3xl">
        <div className="mb-12 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight text-primary sm:text-4xl">
            <span className="border-b-4 border-secondary pb-1">D</span>omande Frequenti
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border bg-card rounded-md border shadow-md">
              <AccordionTrigger className="font-default hover:text-secondary px-6 py-4 text-base font-medium transition-colors hover:no-underline text-primary">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground font-sans px-6 pb-6 pt-2 text-base leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}